import { useQuery } from "@tanstack/react-query";
import { findAllMotifsSupport } from "../services/motifs-support.service";
import { ksMotifsSupportQK } from "../query-keys";

export const useMotifsSupport = () =>
  useQuery({
    queryKey: [ksMotifsSupportQK],
    queryFn: findAllMotifsSupport,
  });
